import gql from 'graphql-tag'

import apolloClient from '@/vendor/apollo'

export function getSummary (cycleId, departmentIds = []) {
  return apolloClient.query({
    query: gql`
      query GetSummary ($cycleIds: [Int], $departmentIds: [Int]) {
        # 在职总人数
        totalCount: report__user_count (cycle_ids: $cycleIds, dept_ids: $departmentIds)
        # 填写人数
        filledInCount: report__okr_count (cycle_ids: $cycleIds, dept_ids: $departmentIds)
        # 发布人数
        publishedCount: report__published_count (cycle_ids: $cycleIds, dept_ids: $departmentIds)
        # 对齐人数
        alignedCount: report__linked_count (cycle_ids: $cycleIds, dept_ids: $departmentIds)
        # 更新人数
        updatedCount: report__updated_count (cycle_ids: $cycleIds, dept_ids: $departmentIds)
        # 复盘人数
        reviewedCount: report__reviewed_count (cycle_ids: $cycleIds, dept_ids: $departmentIds)
      },
    `,
    variables: {
      cycleIds: [cycleId],
      departmentIds
    }
  }).then(res => res.data)
}

export function getDepartmentsRates (cycleId, departmentIds = []) {
  return apolloClient.query({
    query: gql`
      query GetDepartmentsRates ($cycleIds: [Int], $departmentIds: [Int]) {
        report__department_stat (cycle_ids: $cycleIds, dept_ids: $departmentIds)
      }
    `,
    variables: {
      cycleIds: [cycleId],
      departmentIds
    }
  }).then(res => res.data.reportDepartmentStat)
}

export function getStatesPercents (cycleId, departmentIds = []) {
  return apolloClient.query({
    query: gql`
      query GetStatesPercents ($cycleIds: [Int], $departmentIds: [Int]) {
        report__kr_stat (cycle_ids: $cycleIds, dept_ids: $departmentIds)
      }
    `,
    variables: {
      cycleIds: [cycleId],
      departmentIds
    }
  }).then(res => res.data.reportKrStat)
}

export function getTotalCount (cycleId, departmentIds = []) {
  return apolloClient.query({
    query: gql`
      query GetTotalCount ($cycleIds: [Int], $departmentIds: [Int]) {
        report__user_count (cycle_ids: $cycleIds, dept_ids: $departmentIds)
      }
    `,
    variables: {
      cycleIds: [cycleId],
      departmentIds
    }
  }).then(res => res.data.reportUserCount)
}

export function getUserStatus (
  cycleId,
  departmentIds = [],
  limit = 10,
  offset = 0,
  filters = [],
  order
) {
  return apolloClient.query({
    query: gql`
      query GetUserStatus ($cycleIds: [Int], $departmentIds: [Int], $limit: Int, $offset: Int, $filters: JSON, $order: JSON) {
        report__user_stat (cycle_ids: $cycleIds, dept_ids: $departmentIds, limit: $limit, offset: $offset, filters: $filters, order: $order)
        report__user_count (cycle_ids: $cycleIds, dept_ids: $departmentIds, filters: $filters)
      }
    `,
    variables: {
      cycleIds: [cycleId],
      departmentIds,
      limit,
      offset,
      filters,
      order
    }
  }).then(res => res.data)
}
